module.exports = __webpack_public_path__ + "media/images/user-73647178654a330fc28d81790a49cc4e.png";